import React, { useContext } from "react";
import { AuthContext } from "../../../../../../Base/Context/AuthContext/AuthContext";
import AgGrid from "../../../../../../Base/Components/Tables/AgGrid/AgGrid";
import { Dropdown } from "primereact/dropdown";
import { confirmDialog } from "primereact/confirmdialog";
import { toastShow } from "../../../../../../Base/Services/ToastService";
import { chageEstadoRedTelefonia } from "../../../../../../API/IT/Dispositivos/DispositivosRequest";

const RedTelefoniaScreen = ({
  redTelefonias,
  selected,
  setSelected,
  loading,
  setShowDialog,
  toast,
  estados,
  getInfo,
}) => {
  const { userAuth } = useContext(AuthContext);

  const changeEstado = ({ data, api }) => {
    return (
      <div>
        <Dropdown
          value={estados.filter((e) => e.IdStatus === data.IdStatus)[0]}
          options={estados}
          optionLabel="StatusName"
          filter
          filterBy="StatusName"
          placeholder="Estados"
          style={{ width: "100%" }}
          onChange={(e) => {
            let changes = [];
            if (selected.length > 0) {
              changes = selected.map((item) => {
                return {
                  IdTelefonia: item.IdTelefonia,
                  IdEstado: e.value.IdStatus,
                  StatusName: e.value.StatusName,
                };
              });
            } else {
              changes.push({
                IdTelefonia: data.IdTelefonia,
                IdEstado: e.value.IdStatus,
                StatusName: e.value.StatusName,
              });
            }
            confirmDialog({
              message: `¿Cambiar a estado ${e.value.StatusName}?`,
              header: "Confirmación",
              icon: "pi pi-exclamation-triangle",
              accept: async () => {
                let IdRedTelefonias = changes.map((item) => item.IdTelefonia);
                cambiarEstado(e.value.IdStatus, IdRedTelefonias.toString());
                getInfo();
                api.stopEditing();
              },
              reject: () => {},
            });
          }}
        />
      </div>
    );
  };

  const cambiarEstado = async (IdStatus, IdRedTelefonias) => {
    const result = await chageEstadoRedTelefonia({ IdStatus, IdRedTelefonias });
    toastShow(toast, "success", "Actualizado", "Estado cambiado exitosamente");
    setSelected([]);
  };

  const colums = [
    {
      field: "IdTelefonia",
      header: "ID",
      headerEn: "ID",
      className: "XXsmall",
      hidden: userAuth.IdRol === 1,
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "DireccionIP",
      header: "IP",
      headerEn: "IP",
      className: "large",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "NombreDispositivo",
      header: "Nombre Dispositivo",
      headerEn: "Name Device",
      className: "large",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "Extencion",
      header: "Extensión",
      headerEn: "Extension",
      className: "large",
    },
    {
      field: "TipoDispositivo",
      header: "Tipo Dispositivo",
      headerEn: "Type Device",
      className: "large",
    },
    {
      field: "Marca",
      header: "Marca",
      headerEn: "Brand",
      className: "large",
    },
    {
      field: "Modelo",
      header: "Modelo",
      headerEn: "Model",
      className: "large",
    },
    {
      field: "Serie",
      header: "Serie",
      headerEn: "Serial",
      className: "large",
    },
    {
      field: "NombreActivo",
      header: "Activo",
      headerEn: "Asset",
      className: "large",
    },
    {
      field: "Area",
      header: "Area",
      headerEn: "Area",
      className: "large",
    },
    {
      field: "ClaseRango",
      header: "Clase",
      headerEn: "Class",
      className: "large",
    },
    {
      field: "NombreConcatenado",
      header: "Asignado",
      headerEn: "Assigned",
      className: "large",
    },
    {
      field: "Comentario",
      header: "Comentario",
      headerEn: "Comment",
      className: "XXXXXlarge",
    },
    {
      header: "Estado",
      headerEn: "Status",
      frozen: true,
      alignFrozen: "right",
      field: "IdEstado",
      className: "small",
      Format: "Estado",
      filter: false,
      body: (rowData) => ({
        ID: rowData.StatusName,
        Estado: rowData.StatusName,
      }),
      cellEditor: changeEstado,
      editable: true,
    },
    {
      field: "IdTelefonia",
      className: "",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          tooltipOptions: { position: "left" },
          className: "custom-tooltip",
          onClick: (rowData) => {
            setShowDialog(true);
            setSelected(rowData);
          },
        },
      ],
    },
  ];

  const table = {
    Columns: colums,
    Data: redTelefonias,
    loading: loading,
    selected: selected,
    setSelected: setSelected,
  };

  return (
    <div
      className="p-fluid"
      style={{ width: "100%", height: "100%", margin: "auto" }}
    >
      <AgGrid table={table} />
    </div>
  );
};

export default RedTelefoniaScreen;
